<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" class="support" fxLayoutAlign="center center">
    <div fxLayout="column" class="container" fxLayoutAlign="center center">
      <img src="/assets/split-screen-v3/support.webp" />
      <h2>Veteran-led customer service standing by</h2>
      <p>
        To reach the ReSupply’s veteran-led support team, you can text us at
        <a [attr.href]="preview ? null : 'sms:+1 (857) 342-4937'">+1 (857) 342-4937</a>
        or email us at
        <a [attr.href]="preview ? null : 'mailto:donorsupport@resupplyme.com'">{{ 'donorsupport@resupplyme.com' }}</a>
        . We are available Monday to Friday from 8 AM to 8 PM EST, and Saturday from 8 AM to 4 PM EST (excluding holidays).
      </p>
    </div>
    <div class="buttons" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutAlign="center center">
      <a
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-lg="center center"
        fxLayoutGap="10px"
        class="primary"
        [attr.href]="preview ? null : 'sms:+1 (857) 342-4937'"
      >
        <span fxFlex="100" fxFlex.lt-lg="0">Text us via SMS</span>
        <mat-icon svgIcon="ss3-sms" />
      </a>
      <button
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-lg="center center"
        fxLayoutGap="10px"
        class="primary"
        (click)="openZendesk()()"
      >
        <span fxFlex="100" fxFlex.lt-lg="0">Chat with our agent</span>
        <mat-icon svgIcon="ss3-chat" />
      </button>
      <a
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-lg="center center"
        fxLayoutGap="10px"
        class="primary"
        [attr.href]="preview ? null : 'mailto:donorsupport@resupplyme.com'"
      >
        <span fxFlex="100" fxFlex.lt-lg="0">Send us an Email</span>
        <mat-icon svgIcon="ss3-email" />
      </a>
    </div>
  </div>
</div>
